import React, { useState } from "react";
import { Tab, Tabs, Accordion, Card, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";

const VerticalTabs = () => {
  const [activeTab, setActiveTab] = useState("FAQ");

  const handleSelect = (key) => {
    setActiveTab(key);
  };

  return (
    <div className="container mt-5">
      <Tabs
        activeKey={activeTab}
        onSelect={handleSelect}
        className="tab-btn mb-3"
        variant="pills"
        justify
      >
        <Tab eventKey="FAQ" title="FAQ">
          <h3>Frequently Asked Questions</h3>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>What is $SAVEJAMES coin?</Accordion.Header>
              <Accordion.Body>
                $SAVEJAMES is not a donation coin but a movement coin to raise
                awareness, particularly against child castration and Radical
                Feminism, which threatens masculinity in society. The movement
                aims to provide justice for Jeff Younger and Save James. This
                campaign gives supporters a chance to invest in the movement
                while showcasing the application of Blockchain Technology and
                cryptocurrency in society.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>HOW TO BUY $SAVEJAMES</Accordion.Header>
              <Accordion.Body>
                You can participate by joining our movement on social media,
                donating to our cause, sharing your story, or educating others
                about the importance of protecting children. Every action makes
                a difference.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                Can I volunteer with the Save James campaign?
              </Accordion.Header>
              <Accordion.Body>
                Yes, we welcome volunteers to help spread awareness, support our
                legal efforts, and assist with community outreach. You can sign
                up through our website to get involved. Additionally, you can
                contribute by donating your time and energy through social media
                to raise awareness and support the movement.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                Where can I learn more about the campaign's goals?
              </Accordion.Header>
              <Accordion.Body>
                You can learn more about the Save James campaign's mission,
                vision, and goals by visiting our website, reading our
                manifesto, or following us on social media. We provide regular
                updates on our progress and upcoming initiatives.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header>
                What if Jeff Younger sells all his Tokens?
              </Accordion.Header>
              <Accordion.Body>
                Jeff Younger loves James more than himself and will not exchange
                his legacy for anything. He has vowed to carry this movement,
                and having $SAVEJAMES in the liquidity pool will be beneficial
                for the community. Along with Jeff's help, we aim to create an
                INGO bigger than existing organizations like Save Our Soul and
                Save The Children, to support those in need around the world,
                verified through Blockchain Technology.
                <br />
                You can find details here:
                <a
                  href="https://x.com/JeffYoungerShow/status/1876065484606410786"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark"
                >
                  <strong>Jeff's Status on X</strong>
                </a>{" "}
                and check the vested supply:
                <a
                  href="https://app.streamflow.finance/contract/solana/mainnet/9FySYV9DrRgvvmndyANrMBVSNimFDaG9VvXDThgyVy6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-dark"
                >
                  <strong>Streamflow Contract</strong>
                </a>
                .
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header>
                What about participation from other crypto ecosystems?
              </Accordion.Header>
              <Accordion.Body>
                Yes, we are working to spread awareness in every crypto
                ecosystem worldwide using proper technology. Our aim is to
                amplify our voice on the internet while respecting everyone's
                preferred crypto ecosystem. This will be done soon as the
                movement grows bigger and louder.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        <Tab eventKey="About" title="About">
          <h3>About the Save James Campaign</h3>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                What is the Save James campaign?
              </Accordion.Header>
              <Accordion.Body>
                The Save James campaign is a movement focused on raising
                awareness about protecting children from irreversible medical
                interventions. We aim to empower communities, provide resources,
                and expose injustices that harm vulnerable children.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>Who is behind the campaign?</Accordion.Header>
              <Accordion.Body>
                The Save James campaign is driven by passionate individuals,
                organizations, and advocates committed to protecting children’s
                rights. The movement is powered by support from global
                communities and activists.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        <Tab eventKey="Vision" title="Vision">
          <h3>Our Vision</h3>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>What is the long-term goal?</Accordion.Header>
              <Accordion.Body>
                Our long-term goal is to protect children from harmful medical
                practices and provide families with the tools and support they
                need to make informed decisions for their children's futures.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                How does the campaign operate?
              </Accordion.Header>
              <Accordion.Body>
                The Save James campaign operates through a global network of
                activists, legal experts, healthcare professionals, and
                communities working together to create sustainable change. We
                raise awareness, provide financial and legal support, and
                encourage advocacy.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>Why is this different?</Accordion.Header>
              <Accordion.Body>
                The Save James campaign is unique because it combines grassroots
                activism with a powerful financial tool—the $SAVEJAMES
                coin—allowing supporters to make a tangible impact while
                building wealth for themselves and their communities.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        <Tab eventKey="Manifesto" title="Manifesto">
          <h3>Our Manifesto</h3>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Doing Well by Doing Good</Accordion.Header>
              <Accordion.Body>
                At Save James, we believe that doing good for the world aligns
                with doing well for yourself. By supporting our cause, you are
                contributing to a brighter future for children everywhere while
                also helping to build financial opportunities for supporters.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>A Crisis We Must Address</Accordion.Header>
              <Accordion.Body>
                Many children are subjected to irreversible medical
                interventions that harm their bodies and futures. The Save James
                movement seeks to put an end to these practices and provide
                families with the resources they need to protect their children.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>Empowering Change</Accordion.Header>
              <Accordion.Body>
                Through the $SAVEJAMES coin, we empower supporters to become
                part of the change they wish to see in the world. Each
                transaction funds advocacy efforts, legal defenses, and public
                awareness campaigns to protect children from harmful medical
                practices.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              <Accordion.Header>
                How You Can Do Well by Doing Good
              </Accordion.Header>
              <Accordion.Body>
                Support the Save James movement by investing in the $SAVEJAMES
                coin, sharing our mission on social media, and donating to fund
                local grassroots efforts. Together, we can build a brighter,
                safer future for children.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>
      </Tabs>
    </div>
  );
};

export default VerticalTabs;
